export default __webpack_public_path__ + "static/AndrewJohnson-688ce128b6c806455f42b2c2c903c25d.jpg";